import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css';

import Vue from 'vue';
import chart from 'chart.js';
import moment from 'moment';
import VueGtag from 'vue-gtag';
import App from './App.vue';
import router from './router';
import { store } from './store/store';

Vue.use(VueGtag, {
  config: { id: 'G-TC3V61JNDT' },
});

// see docs for available options
const datepickerOptions = {
  dateLabelFormat: 'dddd, MMMM D, YYYY',
  days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  daysShort: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
  monthNames: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  colors: {
    selected: '#4a5b68',
    inRange: '#7d8b96',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#b4bfc8',
    disabled: '#fff',
  },
  texts: {
    apply: 'APPLY',
    cancel: 'RESET',
    keyboardShortcuts: '',
  },
};

// make sure we can use it in our components
Vue.use(AirbnbStyleDatepicker, datepickerOptions);

Vue.config.productionTip = false;

Vue.prototype.moment = moment;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  chart,
  components: { App },
  template: '<App/>',
});

Chart.defaults.global.defaultFontColor = '#4a5b68';
Chart.defaults.global.defaultFontFamily = 'Europa';
Chart.defaults.global.defaultFontStyle = 'bold';
Chart.defaults.global.defaultFontSize = 14;

// SUMMARY CHART IMG PLACE HOLDERS
window.summaryFlagBreakdownChartImg = '';

// Vars to store the chart instance. We need to do this on the window global
// as we need to destroy them before updating to stop old data showing through on hover.
window.chart = [];
window.industryChart = [];
